import React from 'react';

export class ErrorBoundary extends React.Component {

	state = {
		error: null,
	}

	render() {
		const { title, recover } = this.props;
		if (this.state.error) {
			const { message, stack, componentStack } = this.state.error;
			return (
				<div className="error-boundary">
					<h2>{title || '发生错误'}</h2>
					{ recover }
					<p>{message}</p>
					<pre>{stack}</pre>
					<pre>Occured{componentStack}</pre>
				</div>
			)
		}
		return this.props.children;
	}

	componentDidCatch(err, { componentStack }) {
		this.setState({
			error: {
				message: err.message || '渲染错误',
				stack: err.stack,
				componentStack,
			}
		})
	}

	clear() {
		this.setState({ error: null });
	}
}



// WEBPACK FOOTER //
// ./lib/ErrorBoundary.jsx